import { call, put, takeLatest, select } from 'redux-saga/effects';

import { api } from './api';
import { environment } from 'environments/environment';
import { NotifyEventPaymentPaymentInfoRequest } from 'generated/bffNotifyEvent/models';
import { ExtendedAxiosResponse } from 'helpers/apiClient';
import { AppAction, createActionType, createApiActionCreators, RequestActionTypes } from 'helpers/redux/reduxHelpers';
import { ApiClientRequest } from 'models/ApiClientRequest';
import { ExternalUser } from 'models/context/ExternalUser';
import { getApiUrl, performApiCall } from 'saga/apiClient/ducks';
import { selectContextExternalUser } from 'saga/context/external/ducks';
import { getKahlActions } from 'saga/kahl/ducks';
/* ACTION TYPES */

export enum NotifyEventPaymentPaymentInfoTypes {
  PostNotifyEventPaymentPaymentInfo = '@@Billing/POST_PAYMENT_INFO',
}

/* ACTIONS */
export const postNotifyEventPaymentPaymentInfoActions = createApiActionCreators(
  NotifyEventPaymentPaymentInfoTypes.PostNotifyEventPaymentPaymentInfo
);

/* SAGAS */

function* postNotifyEventPaymentPaymentInfo({ payload }: AppAction<NotifyEventPaymentPaymentInfoRequest>) {
  const contextExternalUser: ExternalUser | null = yield select(selectContextExternalUser);

  const request: ApiClientRequest = {
    apiCall: call(api.postNotifyEventPaymentPaymentInfo, yield getApiUrl(environment.urlConfig.notifyEvent), payload),
  };
  const resp: ExtendedAxiosResponse = yield call(performApiCall, request);

  if (resp.ok) {
    if (payload.directProfilePreferredType === 'SMS') {
      yield put(
        getKahlActions.request({
          infoMessageIds: 'ID1043',
          // eslint-disable-next-line
          exceptionParamMaps: { 'Tel.Číslo_KO': contextExternalUser?.phoneNoMobile },
        })
      );
    } else {
      yield put(
        getKahlActions.request({
          infoMessageIds: 'ID1044',
          // eslint-disable-next-line
          exceptionParamMaps: { Email_KO: contextExternalUser?.email },
        })
      );
    }
  } else {
    yield put(postNotifyEventPaymentPaymentInfoActions.failure());
    yield put(getKahlActions.request({ infoMessageIds: 'ID0013' }));
  }
}

/* EXPORT */
export function* notifyEventPaymentPaymentInfoSaga() {
  yield takeLatest(
    createActionType(NotifyEventPaymentPaymentInfoTypes.PostNotifyEventPaymentPaymentInfo, RequestActionTypes.REQUEST),
    postNotifyEventPaymentPaymentInfo
  );
}
